import React from "react";
import { goToCheckout, CHECKOUT_URL } from "../utils/pixel";
export function MobileCtaBar() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-ink/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-86" data-mp="1oxvphvch5i35">
      <div className="flex items-center gap-3" data-id="element-87" data-mp="1t1jxgf50qfox">
        <div className="leading-tight" data-id="element-88" data-mp="1xzd0izb0ytkz">
          <p className="text-xs text-mute line-through" data-id="element-89" data-mp="1xyaa0shm6t5l">67 $</p>
          <p className="font-display text-2xl text-gold" data-id="element-90" data-mp="119cgfdllp1a0">27 $</p>
        </div>
        <a href={CHECKOUT_URL} onClick={e => {
        e.preventDefault();
        goToCheckout();
      }} className="flex-1 rounded-full bg-gold py-3.5 text-center text-sm font-bold text-ink active:scale-[0.98] transition-transform duration-150 ease-out" data-id="element-91" data-mp="1179go1unbts3">
          Je veux le livre + 6 bonus
        </a>
      </div>
    </div>;
}